import React from 'react';
import { Avatar, Divider } from 'antd';
import { isEmpty } from 'lodash-es';
import { AvatarPlaceholderIcon } from 'components/common/SVGIcon';
import { getParentProfileData } from 'redux/contacts/selectors';
import { useSelector } from 'react-redux';
import ParentContact from './ParentContact';

const ContactInfo = () => {
  const parentProfileData = useSelector(getParentProfileData);

  return (
    <div className="rounded-8 relative bg-white">
      <div className="flex-center pt-24">
        <Avatar
          icon={<AvatarPlaceholderIcon className="text-gray-400" />}
          src={parentProfileData?.avatar}
          size={148}
        />
      </div>

      <div className="p-24">
        <ParentContact
          title="contacts.parentGuardianContact"
          item={parentProfileData}
        />

        {!isEmpty(parentProfileData?.additionalParentInfo) && (
          <>
            <Divider />
            <ParentContact
              title="contacts.parentGuardian2"
              item={parentProfileData?.additionalParentInfo}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ContactInfo;
